import Button from './Button';
import classes from './Prompt.module.scss';

function Prompt(props) {
    return (
        <div className={classes.prompt}>
            <div className={classes.title}>{props.title}</div>
            <div className={classes.text}>{props.text}</div>
            <div className={classes.action}>
                <Button onBtnClick={props.onHideModal}>Close</Button>
            </div>
        </div>
    )
}

export default Prompt
